import { isNumber } from 'lodash';
import React, { FC, useRef, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { donationDataStore } from 'src/store/donationFee';
import { getMemberInfo } from 'src/utils/common';
import {
  errorModalViewStore,
  loadingModalViewStore,
  confirmModalViewStore,
  contentModalDep2ViewStore,
} from 'src/store/modal';
import { fetchInsertDonationData, fetchUpdateDonationData } from 'src/fetch/stepC/donation';

import InputBox from 'src/components/atoms/input/DefInputBox';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import LabelSelect from 'src/components/atoms/selectbox/LabelSelect';
import DefLabel from 'src/components/atoms/label/LabelContnet';
import CheckBox from 'src/components/atoms/CheckBox';
import HelpButton from 'src/components/atoms/buttons/HelpButton';
import Description from 'src/components/molecules/table/Description/Donation';
import { getBizNo, formatBizNo, validateBizNo } from 'src/utils/charSet';
import {
  settlementNtsDataStore,
  ntsFileDataStore,
  settlementDataStore,
} from 'src/store/settlementInfo';
import { addComma } from 'src/utils/common';

interface Props {
  data: any;
  type: string;
}
const GridAdd: FC<Props> = ({ data, type }) => {
  const userInfoData: any = getMemberInfo();

  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const setContentModalState = contentModalDep2ViewStore((state: any) => state.set);

  const storeData = donationDataStore((state: any) => state.result).data || [];
  const storeInitPayload = donationDataStore((state: any) => state.initPayload);
  const storePayload = donationDataStore((state: any) => state.payload);
  const storePayloadBind = donationDataStore((state: any) => state.bindPayload);
  const bindStoreParam = donationDataStore((state: any) => state.param);
  const bindStoreBindParam = donationDataStore((state: any) => state.bindParam);

  // 정산결과
  const settlementBindParam = settlementDataStore((state: any) => state.bindParam);
  const settlementParam = settlementDataStore((state: any) => state.param);
  // 정산결과(NTS)
  const ntsInfoBindParam = settlementNtsDataStore((state: any) => state.bindParam);
  const ntsInfoParam = settlementNtsDataStore((state: any) => state.param);
  // NTS 업로드파일 데이터
  const ntsFileBindParam = ntsFileDataStore((state: any) => state.bindParam);
  const ntsFileParam = ntsFileDataStore((state: any) => state.param);

  useEffect(() => {
    if (type === 'insert') {
      storePayloadBind({ ...storeInitPayload });
    } else {
      console.log('datadatadata', data);
      const storeData = data.infoData;
      for (const key in storePayload) {
        if (storeData) storePayload[key] = storeData[key];
      }
      storePayloadBind({ ...storePayload, name: data.name });
    }
  }, [storeData]);

  const familyDataSet = storeData;
  const familySet = familyDataSet.map((item: any) => {
    return { id: item.family_seqid, value: item.name };
  });
  familySet.unshift({ id: '', value: '선택' });
  const checkedFamily =
    storePayload.family_seqid === 0
      ? familySet[0]
      : { id: storePayload.family_seqid, value: storePayload.name };

  const familySelect = {
    checked: checkedFamily,
    options: familySet,
  };

  const dataTypeSet = [
    { id: '', value: '선택' },
    {
      id: '10',
      value: '특례기부금',
    },
    {
      id: '20',
      value: '정치자금기부금',
    },
    {
      id: '40',
      value: '일반기부금(종교단체 외)',
    },
    {
      id: '41',
      value: '일반기부금(종교단체)',
    },
    {
      id: '42',
      value: '우리사주조합기부금',
    },
    {
      id: '43',
      value: '고향사랑기부금',
    },
    // {
    //   id: '50',
    //   value: '지정기부금',
    // },
  ];
  const checkedDataType =
    storePayload.data_type === ''
      ? dataTypeSet[0]
      : {
          id: storePayload.data_type,
          value: dataTypeSet.find((item: any) => item.id === storePayload.data_type)?.value,
        };

  const dataTypeSelect: any = {
    checked: checkedDataType,
    options: dataTypeSet,
  };

  const viewData = data || [];
  const [inpState, setInpState]: any = useState({
    hometaxYN: { value: false },
    commonPayment: { value: '0' },
    commonHouse: { value: '0' },
    traditionFront: { value: '0' },
    traditionBack: { value: '0' },
    traffic: { value: '0' },
    etcFront: { value: '0' },
    etcBack: { value: '0' },
  });

  const help = {
    content: `
      <div className="_hint_content">
        <div className="_item">ㆍ 정치자금기부금, 고향사랑기부금, 우리사주조합기부금은 본인 지출액만 공제가능합니다.</div>
        <div className="_item">ㆍ 『기부장려금 신청금액』은 기부자의 세액공제 대신 기부금 단체에 환급하기 위해 신청한 금액입니다.</div>
        <div className="_item">ㆍ 금액(국세청·기타)에는 『기부장려금 신청금액』과의 합산이 아닌 제외된 공제대상금액을 입력합니다.</div>
      </div>
      `,
    title: '공제 대상 항목',
  };

  const help_t2 = {
    content: `
      <div className="_hint_content">
        <div className="_item">* 사업자 등록번호(주민등록번호)는 '-'를 제외한 숫자만 입력해야 합니다.</div>
      </div>
      `,
    title: '사업자등록번호',
  };

  const selectUser = {
    checked: { id: '', value: '선택' },
    options: [{ id: '1', value: '고길동' }],
  };
  const selectType = {
    checked: { id: '', value: '선택' },
    options: [
      { id: '1', value: '취학전아동' },
      { id: '2', value: '초중고등학교' },
      { id: '3', value: '중고생 교복비' },
      { id: '4', value: '대학교(대학원 불포함)' },
      { id: '5', value: '본인(대학원 등)' },
      { id: '5', value: '장애인 특수교육비' },
      { id: '5', value: '초중고 체험 학습비' },
      { id: '5', value: '학자금대출 상환액' },
      { id: '5', value: '대학입학 전형료, 수능응시료' },
    ],
  };
  const confirmSelect = (item: any, field: string) => {
    if (field === 'family_seqid') {
      storePayloadBind({ ...storeInitPayload, family_seqid: item.id, name: item.value });
    } else {
      storePayload[field] = item.id;
      storePayloadBind({ ...storePayload });
    }
  };

  const confirmEvt = () => {
    storePayload.acct_year = userInfoData.acct_year;
    storePayload.co_cd = userInfoData.co_cd;
    storePayload.co_id = userInfoData.co_id;
    const param: any = storePayload;

    // validation
    const { status } = validationParam(param, 'update');
    if (!status) {
      return false;
    }
    //사업번호 - 제거
    if (param.co_num.indexOf('-') !== -1) {
      param.co_num = param.co_num.replaceAll('-', '');
    }

    fetchInsertDonationData(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindStoreParam.initialSeq || 0;
      bindStoreBindParam({ initialSeq: initialSeq + 1 });

      const initialSetSeq = settlementParam.initialSeq || 0;
      settlementBindParam({ initialSeq: initialSetSeq + 1 });
      const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      const initialFileSeq = ntsFileParam.initialSeq || 0;
      ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      setContentModalState({
        active: '',
      });
    });
  };

  // UPDATE
  const modifyEvt = () => {
    storePayload.acct_year = userInfoData.acct_year;
    storePayload.co_cd = userInfoData.co_cd;
    storePayload.co_id = userInfoData.co_id;
    const param: any = storePayload;

    // validation
    const { status } = validationParam(param, 'update');
    if (!status) {
      return false;
    }
    //사업번호 - 제거
    if (param.co_num.indexOf('-') !== -1) {
      param.co_num = param.co_num.replaceAll('-', '');
    }

    fetchUpdateDonationData(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindStoreParam.initialSeq || 0;
      bindStoreBindParam({ initialSeq: initialSeq + 1 });

      const initialSetSeq = settlementParam.initialSeq || 0;
      settlementBindParam({ initialSeq: initialSetSeq + 1 });
      const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      const initialFileSeq = ntsFileParam.initialSeq || 0;
      ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      setContentModalState({
        active: '',
      });
    });
  };

  const validationParam = (payloadSet: any, type: string) => {
    const resSet = { errText: { main: '', sub: '' }, status: true };
    console.log('validationParam:::', payloadSet);
    const requiredSet = [
      { id: 'name', label: '성명' },
      { id: 'amt', label: '금액(기타)' },
      { id: 'trade_nm', label: '지급처상호' },
    ];
    // Check Required
    for (const item in payloadSet) {
      if (requiredSet.some(req => req.id === item)) {
        let chkValue = payloadSet[item];
        if (typeof chkValue === 'string') chkValue = chkValue.trim() || '';
        if (typeof chkValue === 'number') chkValue = chkValue || 0;
        if (chkValue === '' || chkValue === 0) {
          const label = requiredSet.find((el: any) => el.id === item)?.label;
          resSet.errText.main = `'${label}' 은 필수입력 입니다.`;
          resSet.errText.sub = '해당 값을 입력해 주세요.';
          resSet.status = false;
        }
      }
    }

    //사업자등록번호 체크
    // 123-45-67891
    // 314-15-92650
    // 870-10-23454
    // 555-66-77780
    // 901-23-45674
    if (!validateBizNo(payloadSet.co_num || '')) {
      const targetName = '사업자등록번호';
      resSet.errText.main = `잘못된 ${targetName}입니다.`;
      resSet.errText.sub = `${targetName}를 다시 입력해 주세요.`;
      resSet.status = false;
    }

    if (!resSet.status)
      errorModalState({
        data: { mainTitle: resSet.errText.main, subTitle: resSet.errText.sub },
        active: '_active',
      });

    return resSet;
  };

  const checkClickEvt = (e: React.MouseEvent, type: string) => {
    let useYN = true;
    if (type === 'on') useYN = false;
    setInpState({ ...inpState, hometaxYN: { value: useYN } });
  };

  const inpStrChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const chkValue = e.target?.value || '';
    storePayload[key] = chkValue;
    storePayloadBind({ ...storePayload });
  };
  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    let chkValue = e.target?.value || '';
    chkValue = chkValue.replaceAll(',', '');
    const chkNum = Number(chkValue);
    if (chkNum || chkNum === 0) {
      storePayload[key] = chkNum;
      storePayloadBind({ ...storePayload });
    }
  };

  const inpBizChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const chkValue = e.target?.value || '';

    const resNum = formatBizNo(chkValue);
    console.log(chkValue, resNum);
    if (resNum === false) return false;
    storePayload[key] = resNum;
    storePayloadBind({ ...storePayload });
  };

  return (
    <div className="_add_credit_layout">
      {/* <div className="_desc_div">
        <div className="_main">총 급여의 25% : 10,000,000</div>
        <div className="_sub">신용카드등은 총급여의 25% 이상이어야 공제 가능합니다.</div>
      </div> */}
      <div className="_title_div">
        <div className="_title">공제 대상 항목</div>
        <div className="_help_div">
          <HelpButton content={help.content} title={help.title} styleDef={{ width: '660px' }} />
        </div>
      </div>
      <div className="_inp_div">
        <div className="_opt_div">
          <div className="_item" style={{ zIndex: 20, width: '450px' }}>
            {type === 'insert' ? (
              <LabelSelect
                label="성명"
                select={familySelect}
                labelStyle={{ width: '200px' }}
                boxStyleDef={{ width: 'calc(100% - 200px)' }}
                confirmEvent={confirmSelect}
                field="family_seqid"
              />
            ) : (
              <div className="_title_div">
                <DefLabel
                  label="성명"
                  content={storePayload.name || ''}
                  styleDef={{ color: '#333', fontWeight: '600', fontSize: '15px' }}
                  labelStyleDef={{
                    fontWeight: '500',
                    fontSize: '14px',
                    // width: '80px',
                    paddingRight: '164px',
                  }}
                />
              </div>
            )}
          </div>
          <div className="_item" style={{ zIndex: 15, width: '450px' }}>
            <LabelSelect
              label="기부금 구분"
              select={dataTypeSelect}
              labelStyle={{ width: '200px' }}
              boxStyleDef={{ width: 'calc(100% - 200px)' }}
              confirmEvent={confirmSelect}
              field="data_type"
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'cnt')}
              label="기부건수"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.cnt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>

          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'htx_amt')}
              // inputRef={inpRef}
              label="금액(국세청)"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.htx_amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'amt')}
              // inputRef={inpRef}
              label="금액(기타)"
              status={''}
              required="Y"
              labelPosition="left"
              value={addComma(storePayload.amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpStrChangeEvt(e, 'trade_nm')}
              // inputRef={inpRef}
              label="기부처상호(법인명)"
              required="Y"
              status={''}
              labelPosition="left"
              value={storePayload.trade_nm}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            {/* <div className="_item_set" style={{ zIndex: 5, width: '370px' }}> */}
            <InputBox
              changeEvt={e => inpBizChangeEvt(e, 'co_num')}
              // inputRef={inpRef}
              label="사업자등록번호"
              status={''}
              labelPosition="left"
              value={storePayload.co_num}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
            {/* </div> */}
            {/* <div className="_item_set" style={{ zIndex: 5, width: '20px', marginLeft: 'auto' }}>
              <HelpButton
                content={help_t2.content}
                title={help_t2.title}
                styleDef={{ width: '380px' }}
              />
            </div> */}
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'encourage_req_amt')}
              // inputRef={inpRef}
              label="기부장려금 신청금액"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.encourage_req_amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
        </div>
      </div>
      <div className="_description">
        <Description />
      </div>
      <div className="_btn_div">
        {type === 'insert' ? (
          <DefaultButton
            text="내역 추가"
            styleDef={{ width: '250px' }}
            clickEvent={e => confirmEvt()}
            icon=""
            type="type5"
          />
        ) : (
          <DefaultButton
            text="내역 변경"
            styleDef={{ width: '250px' }}
            clickEvent={e => modifyEvt()}
            icon=""
            type="type3"
          />
        )}
      </div>
    </div>
  );
};

export default GridAdd;
